'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('../..');

var _2 = _interopRequireDefault(_);

var _GridOn = require('material-ui-icons/GridOn');

var _GridOn2 = _interopRequireDefault(_GridOn);

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Grid = (_temp2 = _class = function (_EditorComponent) {
  _inherits(Grid, _EditorComponent);

  function Grid() {
    var _temp, _this, _ret;

    _classCallCheck(this, Grid);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _EditorComponent.call.apply(_EditorComponent, [this].concat(args))), _this), _this.onBeforeDrop = function () {}, _temp), _possibleConstructorReturn(_this, _ret);
  } // static propTypes = {
  //   ...EditorComponent.propTypes,
  // }

  /**
   * Если это контейнер, то дочерним может быть только другой грид.
   * Иначе все остальное.
   */


  Grid.prototype.canBeChild = function canBeChild(child) {
    var can = false;

    if (_EditorComponent.prototype.canBeChild.call(this, child)) {
      var _getComponentProps = this.getComponentProps(this),
          container = _getComponentProps.container;

      if (!container || child instanceof Grid) {
        can = true;
      }
    }

    return can;
  };

  Grid.prototype.getEditorField = function getEditorField(props) {
    var _this2 = this;

    var key = props.key,
        name = props.name,
        value = props.value;

    switch (name) {
      case "container":
      case "item":
        return _react2.default.createElement(_Button2.default, {
          key: key,
          size: 'small',
          variant: 'raised',
          onClick: function onClick(event) {
            // const component = this.getActiveComponent();
            // this.updateComponentProperty(component, name === "container" ? "item" : "container", true);
            _this2.updateComponentProperty(name === "container" ? "item" : "container", true);
          }
        }, name);
        break;
    }

    return _EditorComponent.prototype.getEditorField.call(this, props);
  };

  Grid.prototype.updateComponentProperty = function updateComponentProperty(name, value) {
    switch (name) {
      case "xs":
      case "sm":
      case "md":
      case "lg":
      case "xl":
        if (value === 0) {
          value = true;
        } else if (!value || typeof value !== "number" || value < 0 || value > 12) {
          return false;
        }

        break;
      // case "container":
      //   break;
    }

    return _EditorComponent.prototype.updateComponentProperty.call(this, name, value);
  };

  Grid.prototype.updateComponentProps = function updateComponentProps(data) {
    if (data.container) {
      Object.assign(data, {
        item: undefined,
        xs: undefined,
        sm: undefined,
        md: undefined,
        lg: undefined,
        xl: undefined,
        // alignItems: "flex-end",
        spacing: 0
      });
    } else if (data.item) {
      Object.assign(data, _extends({
        container: undefined,
        alignItems: undefined,
        spacing: undefined
      }, this.getItemDefaultProps()));
    }

    return _EditorComponent.prototype.updateComponentProps.call(this, data);
  };

  Grid.prototype.removeProps = function removeProps(name) {
    switch (name) {
      case "container":
      case "item":
        return false;
        break;
    }

    return _EditorComponent.prototype.removeProps.call(this, name);
  };

  Grid.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, _react2.default.createElement(_GridOn2.default, null), ' Grid'));
  };

  Grid.prototype.prepareNewItem = function prepareNewItem(item) {
    var newItem = _EditorComponent.prototype.prepareNewItem.call(this, item);

    if (!newItem) {
      return false;
    } // const {
    //   dragItem,
    // } = this.getEditorContext();


    var container = this.props.props.container;

    var name = item.name,
        props = _objectWithoutProperties(item.props, []);

    switch (name) {
      case "Grid":
        if (container) {
          delete props.container;
          Object.assign(props, _extends({}, this.getItemDefaultProps(), {
            item: true
          }));
        } else {
          Object.assign(props, {
            container: true,
            // alignItems: "flex-end",
            spacing: 0
          });
        }

        break;
    }

    Object.assign(newItem, {
      props: props
    });
    return newItem;
  };

  Grid.prototype.getItemDefaultProps = function getItemDefaultProps() {
    return {
      xs: 12,
      sm: 6,
      md: 4,
      lg: 3,
      xl: 2
    };
  };

  Grid.prototype.prepareDragItemProps = function prepareDragItemProps() {
    var props = _EditorComponent.prototype.prepareDragItemProps.call(this);

    Object.assign(props, {
      container: true,
      spacing: 0
    });
    return props;
  };

  Grid.prototype.getRootElement = function getRootElement() {
    var MaterialUiGrid = this.context.Grid;
    return MaterialUiGrid;
  }; // renderMainView() {
  //   const {
  //     Grid: MaterialUiGrid,
  //   } = this.context;
  //   const {
  //     props,
  //     ...other
  //   } = this.getRenderProps();
  //   return <MaterialUiGrid
  //     {...other}
  //     {...props}
  //   >
  //     {super.renderMainView()}
  //   </MaterialUiGrid>;
  // }


  Grid.prototype.prepareRootElementProps = function prepareRootElementProps(props) {
    props = _EditorComponent.prototype.prepareRootElementProps.call(this, props);

    if (props.spacing && !props.container) {
      delete props.spacing;
    }

    return props;
  };

  return Grid;
}(_2.default), _class.defaultProps = _extends({}, _2.default.defaultProps, {
  alignItems: undefined
}), _class.Name = "Grid", _temp2);
exports.default = Grid;
module.exports = exports['default'];